"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.19 8.673 13.5 6.92l.002 8.572c0 .132-.053.26-.146.354a.504.504 0 0 1-.354.146H9a.5.5 0 0 1-.5-.5v-2.62H7v-1h2a.5.5 0 0 1 .5.5v2.62h3.002L12.5 5.896h.013L8 1.215l-4.51 4.68h.01v9.083l3.502.014-.004 1-4-.016a.5.5 0 0 1-.498-.5V6.924L.815 8.673l-.72-.694L7.64.147a.514.514 0 0 1 .72 0l7.55 7.832-.72.694Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m23.196 12.902-3.199-3.285.047 13.622a.561.561 0 0 1-.561.563h-5.986a.561.561 0 0 1-.562-.561v-4.108h-2.431v-1.122h2.993c.31 0 .56.251.56.56v4.109h4.863l-.05-14.22L12 1.403 5.026 8.567l.05 14.113h5.428v1.122H4.518a.56.56 0 0 1-.562-.559L3.907 9.715.804 12.902 0 12.12 11.598.207a.58.58 0 0 1 .804 0L24 12.119l-.804.783Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m30.927 17.203-4.264-4.38.062 18.163a.748.748 0 0 1-.748.75h-7.982a.748.748 0 0 1-.748-.748v-5.477h-3.242v-1.497h3.99a.75.75 0 0 1 .749.749v5.477h6.483l-.066-18.96L16 1.87l-9.3 9.551.068 18.818h7.236v1.496h-7.98a.748.748 0 0 1-.749-.745L5.21 12.953l-4.138 4.25L0 16.16 15.464.276a.773.773 0 0 1 1.072 0L32 16.16l-1.073 1.043Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m46.577 25.74-6.745-6.952.105 28.108a.938.938 0 0 1-.937.941H26.625a.938.938 0 0 1-.938-.937v-8.554h-4.312V36.47h5.25c.517 0 .937.42.937.937v8.554H38.06l-.11-29.114L24 2.472 9.938 16.965v28.997h11.438v1.875H9a.938.938 0 0 1-.938-.937V18.897l-6.64 6.843-1.345-1.305L23.327.471a.966.966 0 0 1 1.346 0l23.25 23.962-1.346 1.306Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m62.103 34.32-8.994-9.27.141 37.478A1.251 1.251 0 0 1 52 63.783H35.5c-.69 0-1.25-.56-1.25-1.25V51.127H28.5v-2.5h7c.69 0 1.25.56 1.25 1.25v11.406h13.995l-.146-38.819L32 3.295 13.25 22.62v38.663H28.5v2.5H12c-.69 0-1.25-.56-1.25-1.25V25.196L1.897 34.32.103 32.58l31-31.95c.471-.486 1.323-.486 1.794 0l31 31.95-1.794 1.74Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconHomepage = function IconHomepage(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Homepage' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Homepage"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconHomepage.sizes = [16, 24, 32, 48, 64];
IconHomepage.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconHomepage;
exports.default = _default;